import { h, JSX } from "preact";

import Link from "../../../../foundation/router/Link";
import IconArrowLeft from "../../Icons/IconArrowLeft";
import Button, { ButtonVariant } from "../../Button";

import styles from "./BackButton.module.css";

interface Props {
    class?: string;
    label?: string | JSX.Element;
    to?: string | null;
    onClick?: () => void;
    onPopBackState?: () => void;
}

function BackButton({
    class: cssClass,
    label,
    to,
    onClick,
    onPopBackState
}: Props) {
    return (
        <Link class={cssClass}
            to={to ?? ""}
            onRouterHistoryUpdated={onPopBackState}>
            <Button
                class={styles.backButton}
                variant={ButtonVariant.Ninja}
                icon={IconArrowLeft}
                onClick={onClick}>
                {label}
            </Button>
        </Link>
    );
}

export default BackButton;
